import methods from '../mixins/methods'

const colors = {
  primary: methods.methods.getLocalSettings() && methods.methods.getLocalSettings().color ? methods.methods.getLocalSettings().color : 'bcq',
  bgColorLightness: methods.methods.getLocalSettings() && methods.methods.getLocalSettings().colorLightness ? methods.methods.getLocalSettings().colorLightness : null,
  success: 'green',
  swatches: [{
    color: 'red',
    colorLightness: 500
  }, {
    color: 'yellow',
    colorLightness: 500
  }, {
    color: 'green',
    colorLightness: 500
  }, {
    color: 'blue',
    colorLightness: 500
  }, {
    color: 'bcq',
    colorLightness: null
  }, {
    color: 'indigo',
    colorLightness: 500
  }, {
    color: 'purple',
    colorLightness: 500
  }, {
    color: 'pink',
    colorLightness: 500
  }, {
    color: 'black',
    colorLightness: null
  }]
}

export default colors



// WEBPACK FOOTER //
// ./src/helpers/colors.js